import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fmtDate } from "../lib/api";
import { ShieldCheck, ShieldX, ShieldAlert, Loader2, FileSearch } from "lucide-react";

export default function VerifyPlagiat() {
  const { code } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/recherche/plagiat-verify/${code}`).then(({ data }) => setData(data)).catch(() => setData({ valid: false }));
  }, [code]);

  if (!data) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="animate-spin text-[#0E7C7B]" size={28} /></div>;

  const conform = data.verdict === "conforme";

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-xl items-center px-4 py-16" data-testid="verify-plagiat-page">
      <div className="w-full rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <p className="flex items-center justify-center gap-2 text-center font-mono text-xs uppercase tracking-widest text-[#0E7C7B]">
          <FileSearch size={15} /> Cabinet CARIS Santé — Vérification d'intégrité
        </p>
        {data.valid ? (
          <div className="mt-6 text-center" data-testid="verify-plagiat-valid">
            <div className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full ${conform ? "bg-emerald-100" : "bg-amber-100"}`}>
              {conform ? <ShieldCheck size={34} className="text-emerald-600" /> : <ShieldAlert size={34} className="text-amber-600" />}
            </div>
            <h1 className="mt-4 font-display text-2xl font-bold text-navy">Rapport authentique</h1>
            <p className="mt-1 text-sm text-slate-500">Ce rapport de détection de plagiat a bien été généré par le Cabinet CARIS Santé.</p>
            <div className="mt-6 space-y-3 rounded-2xl bg-slate-50 p-5 text-left text-sm">
              <div className="flex justify-between gap-4"><span className="text-slate-400">Document</span><span className="text-right font-semibold text-navy" data-testid="verify-plagiat-title">{data.title}</span></div>
              {data.author && <div className="flex justify-between gap-4"><span className="text-slate-400">Analysé par</span><span className="font-semibold text-navy">{data.author}</span></div>}
              <div className="flex justify-between gap-4"><span className="text-slate-400">Similarité</span><span className="font-semibold text-[#0E7C7B]" data-testid="verify-plagiat-score">{data.score != null ? `${data.score}%` : "—"}</span></div>
              {data.threshold != null && <div className="flex justify-between gap-4"><span className="text-slate-400">Seuil d'alerte</span><span className="font-semibold text-navy">{data.threshold}%</span></div>}
              <div className="flex justify-between gap-4"><span className="text-slate-400">Verdict</span>
                <span className={`font-semibold ${conform ? "text-emerald-600" : "text-amber-600"}`} data-testid="verify-plagiat-verdict">{conform ? "Conforme" : "À revoir"}</span>
              </div>
              <div className="flex justify-between gap-4"><span className="text-slate-400">Sources détectées</span><span className="font-semibold text-navy">{data.sources_count}</span></div>
              {data.created_at && <div className="flex justify-between gap-4"><span className="text-slate-400">Analysé le</span><span className="font-semibold text-navy">{fmtDate(data.created_at)}</span></div>}
            </div>
          </div>
        ) : (
          <div className="mt-6 text-center" data-testid="verify-plagiat-invalid">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100"><ShieldX size={34} className="text-red-600" /></div>
            <h1 className="mt-4 font-display text-2xl font-bold text-navy">Rapport introuvable</h1>
            <p className="mt-1 text-sm text-slate-500">Aucun rapport ne correspond au code « {code} ». Vérifiez le code ou scannez à nouveau le QR.</p>
          </div>
        )}
      </div>
    </div>
  );
}
